<div class="modal-confirm" data-uit="modal-remove-invalid-files">
    <ca-modal-container [modalTitle]="'FILE_VALIDATION.REMOVAL_DIALOG.TITLE' | translate" (dismiss)="dismiss()">
        <div class="d-flex flex-column">
            <p>
                {{
                    invalidFiles.length > 1
                        ? ('FILE_VALIDATION.REMOVAL_DIALOG.DESCRIPTION_MULTIPLE_FILES' | translate: { numberOfFiles: invalidFiles.length })
                        : ('FILE_VALIDATION.REMOVAL_DIALOG.DESCRIPTION_ONE_FILE' | translate)
                }}
            </p>
            <div class="d-flex flex-column mt-2">
                <span class="text-danger">{{
                    invalidFiles.length > 1
                        ? ('FILE_VALIDATION.REMOVAL_DIALOG.NUMBER_OF_MULTIPLE_INVALID_FILES_MESSAGE' | translate: { numberOfFiles: invalidFiles.length })
                        : ('FILE_VALIDATION.REMOVAL_DIALOG.SINGLE_INVALID_FILES_MESSAGE' | translate)
                }}</span>
                <ca-list-shell
                    class="list-shell"
                    [searchAndSortOptions]="currentSearchOptions"
                    [totalItemsCount]="invalidFiles.length"
                    [updateParameterQuery]="false"
                    [useFirstSortOptionAsDefault]="false"
                    [isSearchInputShown]="false"
                    (onTriggerSearchAndSort)="onFileSearchOrSort($event)"
                >
                    <ca-files-table
                        class="mt-2 text-danger"
                        [actions]="[]"
                        [columns]="['name']"
                        [allFiles]="invalidFiles"
                        [items]="pagedFiles"
                        [totalNumberOfFiles]="invalidFiles.length"
                        [showEmptyRows]="false"
                        [showFileStatus]="true"
                        [showTableHead]="false"
                        [truncateFileNameAtWidthOf]="670"
                        [datasetId]="datasetId"
                        [isSegmentation]="isSegmentation"
                        data-uit="invalid-files-table"
                    >
                    </ca-files-table>
                </ca-list-shell>
            </div>
        </div>
    </ca-modal-container>
    <div class="d-flex justify-content-end">
        <button type="button" caAutoFocus class="btn btn-secondary w-50 mt-4" (click)="dismiss()" data-uit="validation-removal-cancel-btn">
            {{ 'GENERAL.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary w-50 mt-4" (click)="remove()" data-uit="validation-removal-btn">
            {{ 'GENERAL.REMOVE' | translate }}
        </button>
    </div>
</div>
